import { render, staticRenderFns } from "./ui-news-double.vue?vue&type=template&id=7bfa1eec&"
import script from "./ui-news-double.vue?vue&type=script&lang=ts&"
export * from "./ui-news-double.vue?vue&type=script&lang=ts&"
import style0 from "./ui-news-double.vue?vue&type=style&index=0&id=7bfa1eec&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports